import { render, staticRenderFns } from "./AgentServiceModeSwitch.vue?vue&type=template&id=44a75926&scoped=true"
import script from "./AgentServiceModeSwitch.vue?vue&type=script&lang=js"
export * from "./AgentServiceModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceModeSwitch.vue?vue&type=style&index=0&id=44a75926&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a75926",
  null
  
)

export default component.exports